'use es6';

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { isEmpty, identity } from 'underscore';
import { Map as ImmutableMap } from 'immutable';
import { SpecialFieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
import { FieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FormFieldGroup from 'FormsUI/components/editor/form/formFields/FormFieldGroup';
import { addFormFieldGroup as addFormFieldGroupFromAction, addFormField as addFormFieldFromAction, removeFormField as removeFormFieldFromAction, moveFormFieldIntoNewFormFieldGroup as moveFormFieldIntoNewFormFieldGroupFromAction, moveFormFieldIntoExistingFormFieldGroup as moveFormFieldIntoExistingFormFieldGroupFromAction, addRichText as addRichTextFromAction, removeRichText as removeRichTextFromAction, reorderRichText as reorderRichTextFromAction, updateDraggedItem as updateDraggedItemFromAction } from 'FormsUI/actions/FormDragDrop';
import { getFormGuid, getFormFieldGroups, getHighlightAnimationMap } from 'FormsUI/selectors/FormDefinition';
import { getIsPaymentsConfigured } from 'FormsUI/selectors/Payments';
import { removeDependentField as removeDependentFieldFromAction } from 'FormsUI/actions/FormSmartOptions';
import { isFormLabelPropertyEnabled } from 'forms-utils-lib/settings/selectors';
import generateFormFieldGroupKey from 'FormsUI/utils/generateFormFieldGroupKey';
import { isRichTextInternalIdEqualFieldGroupInternalId } from 'FormsUI/utils/RichText';
import { hidePaymentFieldGroup } from 'FormsUI/utils/PaymentsUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export class FormFieldGroupList extends PureComponent {
  constructor() {
    super();
    this.handleMoveFormFieldIntoExistingFormFieldGroup = this.handleMoveFormFieldIntoExistingFormFieldGroup.bind(this);
  }
  handleMoveFormFieldIntoExistingFormFieldGroup(sourceFormFieldGroupIndex, formFieldName, formFieldPropertyObjectType, targetFormFieldGroupIndex, targetFormFieldIndex) {
    const {
      allFormFormFieldGroups,
      moveFormFieldIntoExistingFormFieldGroup,
      handleRichTextSelect,
      selectedFormItemReference
    } = this.props;
    const sourceFormFieldGroup = allFormFormFieldGroups[sourceFormFieldGroupIndex];
    if (sourceFormFieldGroup.fields.length === 1 && isRichTextInternalIdEqualFieldGroupInternalId(sourceFormFieldGroup, selectedFormItemReference)) {
      handleRichTextSelect(false);
    }
    moveFormFieldIntoExistingFormFieldGroup(sourceFormFieldGroupIndex, formFieldName, formFieldPropertyObjectType, targetFormFieldGroupIndex, targetFormFieldIndex);
  }
  render() {
    const {
      formGuid,
      handleFormFieldSelect,
      selectedFormItemType,
      selectedFormItemReference,
      addFormField,
      removeFormField,
      removeDependentField,
      handleRichTextSelect,
      addFormFieldGroup,
      moveFormFieldIntoNewFormFieldGroup,
      addRichText,
      removeRichText,
      reorderRichText,
      updateDraggedItem,
      formFieldGroups,
      isQueued,
      showHighlightAnimationMap,
      formType,
      paymentsConfigured
    } = this.props;
    if (isEmpty(formFieldGroups)) {
      return null;
    }
    let stepNumber = 1;
    const renderedFormFieldGroups = formFieldGroups.filter(fieldGroup => hidePaymentFieldGroup(fieldGroup, paymentsConfigured));
    const groups = renderedFormFieldGroups.map((formFieldGroup, formFieldGroupIndex) => {
      // Handles Queued fields passing null to make correct index
      if (!formFieldGroup) {
        return null;
      }
      if (formFieldGroup.isPageBreak) {
        stepNumber++;
      }
      const key = generateFormFieldGroupKey(formFieldGroup, `${formGuid}-${formFieldGroupIndex}-group`);
      return /*#__PURE__*/_jsx(TFlex, {
        direction: "row",
        justify: "between",
        children: /*#__PURE__*/_jsx(FormFieldGroup, {
          addFormFieldGroup: addFormFieldGroup,
          addFormField: addFormField,
          removeFormField: removeFormField,
          handleRichTextSelect: handleRichTextSelect,
          removeRichText: removeRichText,
          addRichText: addRichText,
          reorderRichText: reorderRichText,
          moveFormFieldIntoExistingFormFieldGroup: this.handleMoveFormFieldIntoExistingFormFieldGroup,
          moveFormFieldIntoNewFormFieldGroup: moveFormFieldIntoNewFormFieldGroup,
          handleFormFieldSelect: handleFormFieldSelect,
          removeDependentField: removeDependentField,
          updateDraggedItem: updateDraggedItem,
          selectedFormItemType: selectedFormItemType,
          selectedFormItemReference: selectedFormItemReference,
          formFields: formFieldGroup.fields,
          richText: formFieldGroup.richText,
          isRichTextLinked: formFieldGroup.fields.length > 0,
          formFieldGroupIndex: formFieldGroupIndex,
          formFieldGroupsLength: renderedFormFieldGroups.length,
          isQueued: isQueued,
          showHighlightAnimation: !!(showHighlightAnimationMap && showHighlightAnimationMap[formFieldGroupIndex]),
          isFormLabelPropertyEnabled: this.props.isFormLabelPropertyEnabled,
          formType: formType,
          isPageBreak: formFieldGroup.isPageBreak,
          stepNumber: stepNumber
        })
      }, key);
    }).filter(identity);
    return /*#__PURE__*/_jsx("div", {
      children: groups
    });
  }
}
FormFieldGroupList.propTypes = {
  formGuid: PropTypes.string.isRequired,
  allFormFormFieldGroups: PropTypes.array.isRequired,
  formFieldGroups: PropTypes.array.isRequired,
  paymentsConfigured: PropTypes.bool.isRequired,
  handleFormFieldSelect: PropTypes.func.isRequired,
  handleRichTextSelect: PropTypes.func.isRequired,
  selectedFormItemType: PropTypes.oneOf([...Object.values(FieldTypes || {}), ...Object.values(SpecialFieldTypes || {})]),
  selectedFormItemReference: PropTypes.string,
  addFormFieldGroup: PropTypes.func.isRequired,
  addFormField: PropTypes.func.isRequired,
  removeFormField: PropTypes.func.isRequired,
  moveFormFieldIntoNewFormFieldGroup: PropTypes.func.isRequired,
  moveFormFieldIntoExistingFormFieldGroup: PropTypes.func.isRequired,
  addRichText: PropTypes.func.isRequired,
  reorderRichText: PropTypes.func.isRequired,
  removeRichText: PropTypes.func.isRequired,
  updateDraggedItem: PropTypes.func.isRequired,
  removeDependentField: PropTypes.func.isRequired,
  isQueued: PropTypes.bool.isRequired,
  formType: PropTypes.string,
  showHighlightAnimationMap: PropTypes.instanceOf(ImmutableMap),
  isFormLabelPropertyEnabled: PropTypes.bool.isRequired
};
const mapStateToProps = state => ({
  formGuid: getFormGuid(state),
  allFormFormFieldGroups: getFormFieldGroups(state),
  showHighlightAnimationMap: getHighlightAnimationMap(state),
  isFormLabelPropertyEnabled: isFormLabelPropertyEnabled(state),
  paymentsConfigured: getIsPaymentsConfigured(state)
});
const actionCreators = {
  addFormFieldGroup: addFormFieldGroupFromAction,
  addFormField: addFormFieldFromAction,
  removeFormField: removeFormFieldFromAction,
  moveFormFieldIntoNewFormFieldGroup: moveFormFieldIntoNewFormFieldGroupFromAction,
  moveFormFieldIntoExistingFormFieldGroup: moveFormFieldIntoExistingFormFieldGroupFromAction,
  addRichText: addRichTextFromAction,
  removeRichText: removeRichTextFromAction,
  reorderRichText: reorderRichTextFromAction,
  updateDraggedItem: updateDraggedItemFromAction,
  removeDependentField: removeDependentFieldFromAction
};
export default connect(mapStateToProps, actionCreators)(FormFieldGroupList);